import type { SavedInstruction } from '@lyrmo/shared';
import { useCallback } from 'react';
import type { ApiClient } from '../../api/client';
import { useAccountList, type AccountList } from './useAccountList';

/**
 * The writer's saved instructions, for the instruction menu. `owner` is who's signed in: null
 * for nobody, who has none, and undefined until that's known.
 */
export function useSavedInstructions(
  client: Pick<ApiClient, 'listSavedInstructions'>,
  owner: string | null | undefined,
): AccountList<SavedInstruction> {
  const load = useCallback(() => client.listSavedInstructions(), [client]);
  return useAccountList(load, owner);
}
